export const SvgTel = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z"
      fill="#3A8EF6" />
    <path
      d="M14 7.00977V7C14 6.44772 14.4477 6 15 6C15.5523 6 16 6.44772 16 7V7.00977C16 7.56205 15.5523 8.00977 15 8.00977C14.4477 8.00977 14 7.56205 14 7.00977Z"
      fill="#3A8EF6" />
    <path
      d="M17 7.00977V7C17 6.44772 17.4477 6 18 6C18.5523 6 19 6.44772 19 7V7.00977C19 7.56205 18.5523 8.00977 18 8.00977C17.4477 8.00977 17 7.56205 17 7.00977Z"
      fill="#3A8EF6" />
    <path
      d="M20 7.00977V7C20 6.44772 20.4477 6 21 6C21.5523 6 22 6.44772 22 7V7.00977C22 7.56205 21.5523 8.00977 21 8.00977C20.4477 8.00977 20 7.56205 20 7.00977Z"
      fill="#3A8EF6" />
  </svg>
)